import styled from "styled-components";
export const ChartJSLineChartWrapper = styled.div `
    padding-left: "2%";
    box-sizing: "border-box";
`;
